import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import { cva } from 'class-variance-authority';
import {
  getCSSColorText,
  getCSSSizeLgText,
  getCSSSizeMdText,
  getCSSSizeSmText,
} from '~/utilities/getCSS';
import { getFontSizeObject } from '~/utilities/getFontSizeObject';
import { ArticleContext } from '~/contexts/ArticleContext';
import { useIsPremiumTemplate } from '~/utilities/useIsPremiumTemplate';
import { useIsOdesaTemplate } from '~/utilities/useIsOdesaTemplate';

const cssClasses = cva('article-intro mb-4', {
  variants: {
    color: getCSSColorText(),
    sizeSm: getCSSSizeSmText(),
    sizeMd: getCSSSizeMdText(),
    sizeLg: getCSSSizeLgText(),
    marginBottom: {
      true: 'md:mb-[20px]',
      false: '',
    },
    isOdesa: {
      true: '!mb-[10px] md:!mb-[20px]',
      false: '',
    },
  },
});

export default component$((): JSX.Element => {
  const {
    themeComponents: { intro },
  } = useContext(AppDataContext);
  const article = useContext(ArticleContext);

  if (!article) return <></>;

  // global css classes are conflicting with the intro css classes
  const html = article.intro?.replaceAll(/(<p>|<\/p>)/g, '');
  const isPremium = useIsPremiumTemplate();
  const isOdesa = useIsOdesaTemplate();
  const css = cssClasses({
    color: intro.introTextColor.value,
    ...getFontSizeObject(intro, 'introTextSizeIn', 'Screen'),
    marginBottom: isPremium,
    isOdesa,
  });

  return <div class={css} dangerouslySetInnerHTML={html} />;
});
